import axios from "axios";
import { useEffect, useState, useCallback } from "react";

export const IS_LOUISE_HOST = /louisegatanas/i.test(window.location.hostname);
export const BASE = IS_LOUISE_HOST ? "" : "/louise";
export const L = (p = "") => `${BASE}${p}` || "/";

const ROOT = `${process.env.REACT_APP_BACKEND_URL}/api/louise`;
export const api = axios.create({ baseURL: ROOT });

export const adminToken = () => localStorage.getItem("lou_admin_token");
export const adminApi = axios.create({ baseURL: `${ROOT}/admin` });
adminApi.interceptors.request.use((c) => {
  const t = adminToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const mediaUrl = (id, admin = false) =>
  id ? `${ROOT}/media/${id}${admin && adminToken() ? `?token=${adminToken()}` : ""}` : null;
export const originalUrl = (id) => `${ROOT}/admin/media/${id}/original?token=${adminToken()}`;
export const exportUrl = (files = true) => `${ROOT}/admin/export?token=${adminToken()}&include_files=${files}`;

export const imgOf = (rec, admin = false) => {
  if (!rec) return null;
  if (rec.media_id) return mediaUrl(rec.media_id, admin);
  if (rec.media_ids?.length) return mediaUrl(rec.media_ids[0], admin);
  return rec.sample_url || rec.sample_urls?.[0] || null;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(". ");
  return d || "Something went wrong. Please try again.";
};

export function useFetch(path, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(() => {
    api.get(path).then((r) => setData(r.data)).catch((e) => setError(errMsg(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  useEffect(() => { load(); }, [load]);
  return { data, error, reload: load };
}

export function useTitle(t) {
  useEffect(() => { document.title = t ? `${t} | Louise Gatanas` : "Louise Gatanas"; }, [t]);
}
